import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 22.63 16.26' {...props}>
    <g data-name='Layer 2'>
      <path
        fill='none'
        stroke='undefined'
        strokeMiterlimit={10}
        strokeWidth={2}
        d='M21.92.71L7.78 14.85.71 7.78'
        data-name='component info'
      />
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CheckIcon.js